/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * BRG Deal of the Day (auto-discount plan, draft 2026-10-19).
 * Liquid (snippets/brg-dotd-price.liquid) renders the deal price; the theme also re-renders the price block from the
 * server on variant change. This hook recomputes the PDP deal price immediately from the new variant's price in cents,
 * using the same math as Shopify's automatic percentage discount: per-unit discount = floor(cents * pct / 100).
 */
(function () {
  function brgFormatMoney(cents) {
    var t = window.theme || {};
    var format = (t.currencyCodeEnabled ? t.moneyWithCurrencyFormat : t.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var withPeriod = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        case 'amount_with_comma_separator': return withPeriod;
        case 'amount_no_decimals_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default: return withComma;
      }
    });
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || typeof variant.price !== 'number') return;
    var root = (event.target && event.target.closest && event.target.closest('.shopify-section')) || document;
    root.querySelectorAll('[data-brg-dotd-pdp]').forEach(function (el) {
      var pct = parseInt(el.getAttribute('data-brg-dotd-pct'), 10) || 10;
      var base = variant.price;
      var deal = base - Math.floor(base * pct / 100);
      el.setAttribute('data-brg-dotd-deal', deal);
      var dealText = el.querySelector('[data-brg-dotd-deal-text]');
      if (dealText) dealText.textContent = brgFormatMoney(deal);
      var regular = el.parentNode && el.parentNode.querySelector('[data-brg-dotd-regular]');
      if (regular) {
        regular.setAttribute('data-brg-dotd-regular', base);
        var regText = regular.querySelector('[data-brg-dotd-regular-text]');
        if (regText) regText.textContent = brgFormatMoney(base);
      }
    });
  });
})();
